import { all } from "axios";

export const arFeedback = {
    feedback: {
        title : 'التعليقات',
        subtitle : 'إدارة وتحليل تعليقات العملاء لتحسين خدماتك',
        filter: {
            allItems : 'جميع الأصناف',
            all : 'جميع المشاعر',
            positive : 'إيجابي',
            negative : 'سلبي',
            customer : 'التعليقات المباشرة',
            ai : 'تعليقات مدعومة بالذكاء الاصطناعي',
        },
        general : 'عام',
        itemFeedback : 'العناصر',
        generalDesc : 'تجربة المطعم العامة',
        itemDesc : 'تعليقات حول أصناف محددة',
        noGeneral : 'لا توجد تعليقات عامة',
        noItem : 'لا توجد تعليقات على الأصناف',
        ratings : 'تقييمات',
        review : 'مراجعة',
        reviews : 'مراجعات',
        rated : 'مقيم',
    },
};